import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Layout, Menu, Typography } from "antd";
import { useAuthContext } from "../context/AuthContext";
import authService from "../services/authService";
import { version } from "../../package.json";
import { ReactComponent as ExportOutlined } from "../assets/icons/exportOutlined.svg";

const { Sider } = Layout;
const { Text} = Typography;

const SideBar = ({ menuItems, matchMenuKey }) => {
  const authContext = useAuthContext();

  const [collapsed, setCollapse] = useState(false);
  const [backendVersion, setBackendVersion] = useState("");

  const onCollapse = (isCollapsed) => {
    setCollapse(isCollapsed);
  };

  const getBackendVersion = async () => {
    const backendVersion = await authService.getBackendVersion();
    setBackendVersion(backendVersion);
  };
  useEffect(() => {
    getBackendVersion();
  }, []);

  return (
    <Sider
      collapsible
      onCollapse={onCollapse}
      collapsed={collapsed}
      breakpoint="lg"
      id="dorNavSider"
    >
      <Menu mode="inline" theme="dark" selectedKeys={[matchMenuKey]}>
        {menuItems.map(({ path, icon, name, rolesAccess }) => {
          if (rolesAccess.includes(authContext.user.role))
            return (
              <Menu.Item key={path} icon={icon} className="display-flex-center">
                {name}
                <Link to={path} />
              </Menu.Item>
            );
        })}
      </Menu>
      {!collapsed && (
        <div className="sidebar-lower-wrapper">
          <div className="sidebar-patent-wrapper">
            <ExportOutlined className="sidebar-patent-icon" />

            <div className="sidebar-patent-text-wrapper">
              <Text className="sidebar-patent-text">Patents</Text>
              <a
                href="https://www.dinamicor.com/patents/"
                target="_blank"
                rel="noopener noreferrer"
                className="sidebar-patent-link"
                style={{ color: "#8c8c8c" }}
              >
                www.dinamicor.com/patents/
              </a>
            </div>
          </div>
          <div className="sidebar-versions">
            <Text className="sidebar-versions-text">
              Version: F-{version} | B-{backendVersion}
            </Text>
          </div>
        </div>
      )}
    </Sider>
  );
};

export default SideBar;
